import { PictureAsPdf, Save, SaveAs } from "@mui/icons-material"
import { BottomNavigation, BottomNavigationAction, Box } from "@mui/material"
import { PDFExportDialog } from "components/PDFExport/PDFExportDialog"
import { Examination, Project, Report } from "graphql/types"
import { useState } from "react"

type ReportLeftBoxFooterProps = {
  report: Report
  project?: Project
  examination?: Examination // For backward compatibility
  hasUnsavedChanges?: boolean
  onSave?: () => void
  onSaveAsNewVersion?: () => void
}

export const ReportLeftBoxFooter = (props: ReportLeftBoxFooterProps) => {
  const { report, project, hasUnsavedChanges, onSave, onSaveAsNewVersion } = props

  const [openPDFExportDialog, setOpenPDFExportDialog] = useState(false)

  return (
    <Box>
      <BottomNavigation showLabels>
        <BottomNavigationAction
          label="Speichern"
          icon={<Save />}
          onClick={onSave}
          disabled={!hasUnsavedChanges}
          sx={{
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
            "&:disabled": {
              color: "rgba(255, 255, 255, 0.1)",
            },
          }}
        />

        <BottomNavigationAction
          label="Neue Version"
          icon={<SaveAs />}
          onClick={onSaveAsNewVersion}
          // disabled={!hasUnsavedChanges}
          sx={{
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
          }}
        />

        <BottomNavigationAction
          label="PDF"
          icon={<PictureAsPdf />}
          onClick={() => setOpenPDFExportDialog(true)}
          sx={{
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            },
          }}
        />
      </BottomNavigation>

      <PDFExportDialog
        report={report}
        project={project}
        examinations={report.examinations}
        useProfessionalFormat={true}
        isPreview={false}
        open={openPDFExportDialog}
        onClose={() => setOpenPDFExportDialog(false)}
      />
    </Box>
  )
}
